// extracted by mini-css-extract-plugin
export default {"text":"StaticFieldText_text__ngRhQ"};